"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledInput = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components")); // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var getSvg = function getSvg(fillColor) {
  return "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" fill=\"".concat(fillColor, "\"><polygon points=\"7.243 13.485 3 9.242 4.414 7.828 7.243 10.657 12.899 5 14.314 6.414\"></polygon></svg>");
};

var StyledInput = /*#__PURE__*/_styledComponents["default"].input.withConfig({
  displayName: "indexstyles__StyledInput",
  componentId: "sc-1giuv7j-0"
})(["appearance:none;width:1rem;height:1rem;vertical-align:middle;cursor:", ";:not(:checked){border:1px solid ", ";}:focus{border:1px solid ", ";outline:1px solid ", ";}:checked{background-color:", ";background-image:url(data:image/svg+xml;base64,", ");}"], function (p) {
  return p.disabled ? 'auto' : 'pointer';
}, function (p) {
  return p.disabled ? p.theme.colorBackgroundChoiceDisabled : p.theme.colorBorderChoice;
}, function (p) {
  return p.theme.colorBorderChoiceFocus;
}, function (p) {
  return p.theme.colorBorderChoiceFocus;
}, function (p) {
  return p.disabled ? p.theme.colorBackgroundChoiceDisabled : p.theme.colorBackgroundChoiceSelected;
}, function (p) {
  return btoa(getSvg(p.theme.tokens.colorBackground));
});

exports.StyledInput = StyledInput;